// Captcha widget IDs for managing multiple instances
export const CAPTCHA_WIDGET_IDS = {
  LEAD_CAPTURE_FORM: 'captcha_widget_lead_capture_form',
  LEAD_CAPTURE_MODAL: 'captcha_widget_lead_capture_modal',
  LEAD_FORM_MODAL2: 'captcha_widget_lead_form_modal2',
  DEFAULT: 'captcha_widget',
} as const;

export type CaptchaWidgetId = (typeof CAPTCHA_WIDGET_IDS)[keyof typeof CAPTCHA_WIDGET_IDS];
